import { render, staticRenderFns } from "./submenu.pug?vue&type=template&id=2ddcff8b&lang=pug&"
import script from "./submenu.ts?vue&type=script&lang=ts&"
export * from "./submenu.ts?vue&type=script&lang=ts&"
import style0 from "./submenu.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports